import { render, staticRenderFns } from "./CambiarEstatus.vue?vue&type=template&id=635e9a79&"
import script from "./CambiarEstatus.vue?vue&type=script&lang=js&"
export * from "./CambiarEstatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports